import { useEffect, useState } from "react";
import DashboardComponentWrapper from "../../../components/DashboardComponentWrapper";
import TabComponent from "../../../components/TabComponent";
import Table from "../../../components/Table";
import { getWorkflowAudits } from "../../../actions/workflow";
import { useNavigate } from "react-router-dom";
import { icons } from "../../../assets";
import DashboardNavItem from "../../../components/DashboardNavItem/DashboardNavItem";
import TableActionsComponent from "../../../components/Table/TableActionsComponent";

const WorkflowAudit = () => {
  const navigate = useNavigate();
  const tabComponents = {
    'Audit': () => <AuditTable />,
  };

  const navItemsObj = [
    {
      label: 'Go back',
      action: () => navigate(-1),
      bgColor: '#0898A0',
      img: icons.closeNav,
    }
  ];

  const renderNavItems = () => {
    return (
      <DashboardNavItem
        navItems={[]}
        navItemsObj={navItemsObj}
        tab={''}
        setTab={() => { }}
      />
    )
  }

  return (
      <DashboardComponentWrapper
        title="Workflow Audit"
        pageDetails="View Audit for your Workflow"
        renderNavItems={renderNavItems}
      >
        <>
          <TabComponent
            components={tabComponents}
          />
        </>
      </DashboardComponentWrapper>
  )
};

export default WorkflowAudit;


const AuditTable = () => {
  const [audits, setAudits] = useState([]);
  useEffect(() => {
    !audits.length && getWorkflowAudits((resp) => {
      setAudits(resp?.data)
    });
  }, []);
  const header = [
    { field: 'eventDateTime', headerName: 'Time' },
    { field: 'recordId', headerName: 'Record Id' },
    { field: 'recordType', headerName: 'Record Type' },
    { field: 'principalId', headerName: 'Principal Id'},
    { field: 'dataSnapShop', headerName: 'Data SnapShop' },
    { field: 'eventType', headerName: 'Event Type'},
    { field: 'user', headerName: 'User' },
    { field: 'auserWorkFlowLevel', headerName: 'User WorkFlow Level'},
    {
      field: "description",
      headerName: "Description",
    }
  ];

  return (
    <div className="accordion !w-full h-[65vh] text-left mt-6">
      <Table data={audits} header={header}        
      />
    </div>
  )
}